export const tradeResponseMutations = {
  
  setTradeResponseMerchantNotificationId(state, payload){
    state.tradeResponseMerchantNotificationId=payload
  },
  setTradeResponseHasResponse(state, payload){
    state.tradeResponseHasResponse=payload
  },  
  setTradeResponseSelectedForEdit(state, payload){
    state.tradeResponseSelectedForEdit=payload
  },
  setTradeResponseIsEdit(state, payload){
    state.tradeResponseIsEdit=payload
  },
  setTradeResponseShowForm(state, payload){
    state.tradeResponseShowForm=payload
  },
  setTradeResponseId(state, payload){
    state.tradeResponseId=payload
  },
  setTradeResponsePageNumber (state, payload){
    state.tradeResponsePageNumber=payload
  },
  setTradeResponseItemsPerPage (state, payload){
    state.tradeResponseItemsPerPage=payload
  },
  setTradeResponseSelectedItem (state, payload){
    state.tradeResponseSelectedItem=payload
  },
  setTradeResponseCurrentList (state, payload){
    state.tradeResponseCurrentList=payload
  },
  setTradeResponseProp (state, payload){
    state.tradeResponseProp=payload
  }
};
